export const GALLERY_COLLECTION_COPY = {
  storage: 'Firebase',
  delivery: 'Lazy-loaded',
};

export const GALLERY_PHOTOS = [
  {
    id: 'gallery-2026-001',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2F123_1.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2F123_1.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 1',
    caption: '123_1',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-002',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_4733.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_4733.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 2',
    caption: 'IMG_4733',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-003',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_4734.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_4734.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 3',
    caption: 'IMG_4734',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-004',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_4735.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_4735.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 4',
    caption: 'IMG_4735',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-005',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_4736.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_4736.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 5',
    caption: 'IMG_4736',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-006',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7787.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7787.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 6',
    caption: 'IMG_7787',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-007',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7857.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7857.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 7',
    caption: 'IMG_7857',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-008',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7858.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7858.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 8',
    caption: 'IMG_7858',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-009',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7859.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7859.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 9',
    caption: 'IMG_7859',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-010',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7860.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7860.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 10',
    caption: 'IMG_7860',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-011',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7861.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7861.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 11',
    caption: 'IMG_7861',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-012',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7862.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7862.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 12',
    caption: 'IMG_7862',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-013',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7863.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7863.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 13',
    caption: 'IMG_7863',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-014',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7864.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7864.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 14',
    caption: 'IMG_7864',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-015',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7865.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7865.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 15',
    caption: 'IMG_7865',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-016',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7866.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7866.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 16',
    caption: 'IMG_7866',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-017',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7867.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7867.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 17',
    caption: 'IMG_7867',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-018',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7868.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7868.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 18',
    caption: 'IMG_7868',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-019',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7869.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7869.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 19',
    caption: 'IMG_7869',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-020',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7870.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7870.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 20',
    caption: 'IMG_7870',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-021',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7871.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7871.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 21',
    caption: 'IMG_7871',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-022',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7872.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7872.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 22',
    caption: 'IMG_7872',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-023',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7873.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7873.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 23',
    caption: 'IMG_7873',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-024',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7874.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7874.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 24',
    caption: 'IMG_7874',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-025',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7875.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7875.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 25',
    caption: 'IMG_7875',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-026',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7876.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7876.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 26',
    caption: 'IMG_7876',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-027',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7877.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7877.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 27',
    caption: 'IMG_7877',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-028',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7878.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7878.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 28',
    caption: 'IMG_7878',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-029',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7879.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7879.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 29',
    caption: 'IMG_7879',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-030',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7880.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7880.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 30',
    caption: 'IMG_7880',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-031',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7881.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7881.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 31',
    caption: 'IMG_7881',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-032',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7882.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7882.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 32',
    caption: 'IMG_7882',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-033',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7883.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7883.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 33',
    caption: 'IMG_7883',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-034',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7884.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7884.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 34',
    caption: 'IMG_7884',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-035',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7885.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7885.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 35',
    caption: 'IMG_7885',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-036',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7886.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7886.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 36',
    caption: 'IMG_7886',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-037',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7887.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7887.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 37',
    caption: 'IMG_7887',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-038',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7888.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7888.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 38',
    caption: 'IMG_7888',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-039',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7889.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7889.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 39',
    caption: 'IMG_7889',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-040',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7890.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7890.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 40',
    caption: 'IMG_7890',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-041',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7891.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7891.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 41',
    caption: 'IMG_7891',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-042',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7892.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7892.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 42',
    caption: 'IMG_7892',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-043',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7893.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7893.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 43',
    caption: 'IMG_7893',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-044',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7894.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7894.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 44',
    caption: 'IMG_7894',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-045',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7895.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7895.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 45',
    caption: 'IMG_7895',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-046',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7896.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7896.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 46',
    caption: 'IMG_7896',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-047',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7897.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7897.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 47',
    caption: 'IMG_7897',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-048',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7898.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7898.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 48',
    caption: 'IMG_7898',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-049',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7899.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7899.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 49',
    caption: 'IMG_7899',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-050',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7900.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7900.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 50',
    caption: 'IMG_7900',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-051',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7901.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7901.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 51',
    caption: 'IMG_7901',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-052',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7902.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7902.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 52',
    caption: 'IMG_7902',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-053',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7903.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7903.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 53',
    caption: 'IMG_7903',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-054',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7904.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7904.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 54',
    caption: 'IMG_7904',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-055',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7905.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7905.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 55',
    caption: 'IMG_7905',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-056',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7906.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7906.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 56',
    caption: 'IMG_7906',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-057',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7907.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7907.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 57',
    caption: 'IMG_7907',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-058',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7908.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7908.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 58',
    caption: 'IMG_7908',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-059',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7909.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7909.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 59',
    caption: 'IMG_7909',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-060',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7910.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7910.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 60',
    caption: 'IMG_7910',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-061',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7911.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7911.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 61',
    caption: 'IMG_7911',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-062',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7912.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7912.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 62',
    caption: 'IMG_7912',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-063',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7913.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7913.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 63',
    caption: 'IMG_7913',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-064',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7914.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7914.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 64',
    caption: 'IMG_7914',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-065',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7915.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7915.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 65',
    caption: 'IMG_7915',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-066',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7916.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7916.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 66',
    caption: 'IMG_7916',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-067',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7917.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7917.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 67',
    caption: 'IMG_7917',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-068',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7918.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7918.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 68',
    caption: 'IMG_7918',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-069',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7919.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7919.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 69',
    caption: 'IMG_7919',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-070',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7920.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7920.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 70',
    caption: 'IMG_7920',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-071',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7921.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7921.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 71',
    caption: 'IMG_7921',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-072',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7945.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7945.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 72',
    caption: 'IMG_7945',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-073',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7946.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7946.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 73',
    caption: 'IMG_7946',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-074',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7948.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7948.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 74',
    caption: 'IMG_7948',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-075',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7951.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7951.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 75',
    caption: 'IMG_7951',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-076',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_7957.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_7957.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 76',
    caption: 'IMG_7957',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-077',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9410.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9410.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 77',
    caption: 'IMG_9410',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-078',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9418.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9418.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 78',
    caption: 'IMG_9418',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-079',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9419.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9419.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 79',
    caption: 'IMG_9419',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-080',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9429.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9429.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 80',
    caption: 'IMG_9429',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-081',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9503.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9503.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 81',
    caption: 'IMG_9503',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-082',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2FIMG_9504.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2FIMG_9504.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 82',
    caption: 'IMG_9504',
    group: '2026 Party',
  },
  {
    id: 'gallery-2026-083',
    partyPath: '',
    src: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Ffull%2Fimage.jpg?alt=media',
    thumbnailSrc: 'https://firebasestorage.googleapis.com/v0/b/mr-oscars.firebasestorage.app/o/gallery%2F2026%2Fthumbs%2Fimage.jpg?alt=media',
    alt: 'Martin-Resnick Oscar Party 2026 photo 83',
    caption: 'image',
    group: '2026 Party',
  },
];
